interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const baseSchemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '爆料网',
      url: 'https://www.baoliao.com',
      description: '爆料网官网提供最新爆料资讯入口，汇聚51爆料网、91爆料网等热门平台内容。每日同步更新吃瓜爆料地址与独家内幕。',
      logo: 'https://www.baoliao.com/logo.png',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-10-88888888',
        contactType: 'customer service',
        areaServed: 'CN',
        availableLanguage: ['Chinese'],
      },
      sameAs: [
        'https://weibo.com/baoliao',
        'https://weixin.qq.com/baoliao',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '爆料网',
      url: 'https://www.baoliao.com',
      description: '爆料网官网提供最新爆料资讯入口，汇聚51爆料网、91爆料网等热门平台内容。每日同步更新吃瓜爆料地址与独家内幕。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.baoliao.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = baseSchemas[type];

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}